import { render, staticRenderFns } from "./BottomSheetAddNiveau.vue?vue&type=template&id=455a8e31&scoped=true&"
import script from "./BottomSheetAddNiveau.vue?vue&type=script&lang=js&"
export * from "./BottomSheetAddNiveau.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetAddNiveau.vue?vue&type=style&index=0&id=455a8e31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a8e31",
  null
  
)

export default component.exports